
import { Megaphone as IconSpeakerphone, X as IconX } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import { Alert } from '@mantine/core';

const SURVEY_ID = "2026-q1";
const DISMISS_KEY = `active-survey-banner-dismissed:${SURVEY_ID}`;
const SURVEY_URL = "https://forms.gle/LiwcoPfyrkN9GtEs5";
const hasSurveyUrl = SURVEY_URL !== "PASTE_SURVEY_URL_HERE";
export default function SurveyBanner() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        try {
            const dismissed = localStorage.getItem(DISMISS_KEY) === "1";
            setIsVisible(!dismissed);
        } catch {
            setIsVisible(true);
        }
    }, []);

    const dismiss = () => {
        try {
            localStorage.setItem(DISMISS_KEY, "1");
        } catch {
            // Ignore storage errors and still hide for this session.
        }
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className="survey-banner">
            <Alert
                severity="info"
                className="w-full survey-banner-message"
                icon={<IconSpeakerphone />}
                withCloseButton={true}
                onClose={dismiss}
                color="blue"
            >
                <div className="survey-banner-inner">
                    <span className="survey-banner-text">Please take a moment to share your feedback. Get a chance to win one year of premium!</span>
                    <a className="survey-banner-link" href={SURVEY_URL} target="_blank" rel="noopener noreferrer">
                        Open Survey
                    </a>
                </div>
            </Alert>
        </div>
    );
}
